import {useQuery} from '@tanstack/react-query'
import {getBanners} from '../../api/banners'
import {queryKeys} from '../../constants/queryKey'

function useGetBannersQuery() {
  return useQuery<IBanners>([queryKeys.banners], () => getBanners({start: 0, perPage: 10}), {})
}

export default useGetBannersQuery
